import { defineMessages } from "react-intl";

export const emptyDataMessages = defineMessages({
  noDataFound: {
    id: "emptyData.noDataFound",
    defaultMessage: "No data found",
  },
  notFound: {
    id: "emptyData.notFound",
    defaultMessage: "Not Found",
  },
});
